export const updateMetaTags = ({ title, description, image, url }) => {
    if (title) {
        document.title = `${title} | ParrotOffice`;
        updateMetaProperty('og:title', title);
        updateMetaProperty('twitter:title', title);
    }

    if (description) {
        updateMetaProperty('description', description, 'name');
        updateMetaProperty('og:description', description);
        updateMetaProperty('twitter:description', description);
    }

    if (image) {
        updateMetaProperty('og:image', image);
        updateMetaProperty('twitter:image', image);
    }

    if (url) {
        updateMetaProperty('og:url', url || window.location.href);
    }
};

const updateMetaProperty = (property, content, attr = 'property') => {
    let element = document.querySelector(`meta[${attr}="${property}"]`);
    if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attr, property);
        document.head.appendChild(element);
    }
    element.setAttribute('content', content);
};
